import { track } from 'src/utils/tracker'

export interface CampaignTrackParams {
  category: string
  scene: string
  position?: number
  tracking_id?: string
}

export const trackCampaignClick = (param: CampaignTrackParams) =>
  track('campaign_click', param)
